<template>
    <div :class="{
                        'width-25' : this.field.key == 'accountInfo.enhancedDueDiligence.dateOfEdd'
                    }">
        <b-form-group
            :label="labelByInstance"
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': requiredFields || this.field.isRequired,
            }"
        >
            <div  :id= "`id_${field._id}`" class="form-group custom-datepicker">
                <date-picker
                
                    v-model="model"
                    v-validate="{
                        required: requiredFields || this.field.isRequired,
                    }"
                    class="form-control"
                    format="DD-MM-YYYY"
                    lang="en"
                    :disabled="loading || this.field.enabled ? false :isDisabled"
                    :data-vv-name="field.label"
                    :class="{
                        // 'is-invalid': errors.has(field.label),
                    }"
                    :end-at="endAt"
                    :start-at="startAt"
                    :default-value="disabledAfter"
                    @input="onInput"
                ></date-picker>
                <i
                    :class="[
                        {
                            'disable-input': false,
                        },
                        'icon-calendar',
                    ]"
                ></i>
            </div>
            <p v-if="note" class="tax-instruction">
                <i class="icon-error_outline"></i>
                <span>
                    {{ note }}
                </span>
            </p>
        </b-form-group>
    </div>
</template>

<script>
import TextField from './TextField'
import DatePicker from 'vue2-datepicker'

export default {
    // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        DatePicker,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: TextField, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            required: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data: function () {
        // console.log(
        //     'date now: ' +
        //         JSON.stringify(
        //             this.$store.state.registration.form.identityInfo.number
        //         )
        // )
        // if (this.field.key === 'basicInfo.dateOfBirth' &&
        //     (this.$store.state.registration.form.identityInfo.number == null ||
        //         this.$store.state.registration.form.identityInfo.number == '')
        // )
        if (this.field.key === 'basicInfo.dateOfBirth')
        {
            let date = new Date()
            // if(this.$route.path.includes('company') || this.$store.getters.form.type=='company')
            // {
            //     date.setFullYear(date.getFullYear() - 0)
            // }
            // else
            // {
            //     date.setFullYear(date.getFullYear() - 18)
            // }
            this.disabledAfter = date
            return date
        }
        return {
            disabledAfter: new Date(),
            isDisabled: false,
            country:process.env.VUE_APP_COUNTRY,
            fieldsToCheck:[
                {
                    field:'accountInfo.strDate',
                    dependency:'accountInfo.isStr'
                },
            ],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        /**
         *
         * @return {string}
         */
        requiredFields()
        {   
        if(process.env.VUE_APP_COUNTRY!='Pakistan' ||
              (
                (
                this.$route.path =='/register-customer'|| this.$route.path =='/register-company'|| this.$route.path =='/register-customer/setup-profile'
                    || this.$route.path =='/register-company/setup-profile'
                )
              && this.field.key === 'basicInfo.dateOfBirth'))
            {
                return false
            }
            return this.field.isRequired
        },
        note() {
            return this.field.note
        }, // End of note() method
        endAt() {
            if (this.field.key == 'basicInfo.dateOfBirth') {
                let date = new Date()
                // if(this.$route.path.includes('company') || this.$store.getters.form.type=='company')
                // {
                //     date.setFullYear(date.getFullYear() - 0)
                // }
                // else
                // {
                //     date.setFullYear(date.getFullYear() - 18)
                // }
                return date
            }
            return ''
        },
        startAt() {
            if (this.field.key == 'identityInfo.expiryDate') {
                return new Date()
            } else {
                return new Date('01/01/1900')
            }
        },
        labelByInstance() {
            // field.label
            if(this.$route.path.includes('company') || this.$store.getters.form.type=='company')
            {
                if (this.field.key == 'basicInfo.dateOfBirth') {
                    return 'Date of Incorporation'
                }
                if (this.field.key == 'identityInfo.expiryDate') {
                    if(process.env.VUE_APP_COUNTRY_TEMP=='UK')
                    {
                        return 'Company Registration Expiry'
                    }
                    return 'Company Registration / Trade License expiry date'
                }
                else
                {
                    return this.field.label
                }
            }
            else
            {
                return this.field.label
            }

        },
    }, // End of Component > methods

    created() {
        if (this.field.key == 'identityInfo.expiryDate' && process.env.VUE_APP_COUNTRY=='Pakistan') {
            this.isDisabled = true
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.identityInfo
                        .isLifetimeExpiry // could also put a Getter here
                },
                (newValue, oldValue) => {
                    //something changed do something
                    // console.log(oldValue)
                    // console.log(newValue)
                    if (newValue == 'Yes') {
                        this.field.isRequired = true
                        this.isDisabled = false
                    } else {
                        this.onInput('')
                        this.field.isRequired = false
                        this.isDisabled = true
                    }
                }
            )
        }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        if (this.field.key == 'identityInfo.expiryDate' && process.env.VUE_APP_COUNTRY=='Pakistan') {
            if (
                this.$store.state.registration.form.identityInfo
                    .isLifetimeExpiry == 'No'
            ) {
                this.field.isRequired = false
                this.isDisabled = true
                this.onInput('')
            } else if (
                this.$store.state.registration.form.identityInfo
                    .isLifetimeExpiry == 'Yes'
            ) {
                this.field.isRequired = true
                this.isDisabled = false
            } else if(this.$route.path =='/register-customer' || this.$route.path == '/register-customer/setup-profile') {
                this.isDisabled = true
            }
            else{
                this.isDisabled = false
            }
        }


        const fieldFound = this.fieldsToCheck.find(fieldObj => fieldObj.field === this.field.key);
        if(fieldFound)
        {
            let fieldName = fieldFound.dependency.split('.')
            let condition=this.$store.state.registration.form[fieldName[0]][fieldName[1]]=='yes'

            if(condition)
            {
                this.isDisabled = false//!this.isDisabled
                this.field.isRequired = true
            }
            else
            {
                this.isDisabled = true//!this.isDisabled
                this.field.isRequired = false
            }
        }
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Handle when the value is updated
         *
         * @return {void}
         */
        onInput(newValue) {
            this.model = newValue
        }, // End of onInput() method
    }, // End of Component > mounted
}
</script>

<style scoped>
.width-25{
    max-width: 25% !important;
}
</style>